/** Presentation reads local demo data; it never mutates operational or booking state. */
const CUES={
 overview:{title:'建筑与运营全景',eyebrow:'ARCHITECTURAL INTELLIGENCE',accent:'#66d9ee',legend:'建筑轮廓 · 设备关联 · 演示数据'},
 spatial:{title:'五层空间逐层解析',eyebrow:'SPATIAL EXPLORATION',accent:'#77c9e5',legend:'CAD 轮廓 · 楼层分离 · 方案示意'},
 environment:{title:'203 实验室空气环境',eyebrow:'ENVIRONMENTAL FIELD',accent:'#5be0d2',legend:'送风 / 排风流向 · 演示示意'},
 operations:{title:'设备状态与关联支路',eyebrow:'ASSET DIAGNOSTICS',accent:'#7fc9f3',legend:'运行 / 停止 / 离线 · 演示状态'},
 energy:{title:'楼层能源空间分布',eyebrow:'ENERGY DISTRIBUTION',accent:'#64d6c7',legend:'分层能耗 · 低 → 高 · 演示快照'},
 business:{title:'空间与仪器使用状态',eyebrow:'LABORATORY ACTIVITY',accent:'#93b9f8',legend:'青绿可预约 · 蓝使用中 · 灰离线 · 演示'}
};
export function pageCue(page){return CUES[page]||CUES.overview;}
export function resourceCue(id,bookings=[],now,asset=null){
 if(asset?.status==='offline')return {key:'offline',label:'离线',color:'#718293'};
 const at=Date.parse(now);const occupied=Number.isFinite(at)&&bookings.some(b=>b.resource===id&&b.status==='active'&&Date.parse(b.start)<=at&&at<Date.parse(b.end));
 return occupied?{key:'occupied',label:'使用中',color:'#79b4f5'}:{key:'available',label:'可预约',color:'#62d7be'};
}
export function presentationBlend(value,target,dt,reducedMotion){
 if(reducedMotion)return target;if(!Number.isFinite(dt)||dt<=0)return value;
 const next=value+(target-value)*(1-Math.exp(-Math.min(dt,.1)*4));return Math.abs(target-next)<.001?target:next;
}
